import React, { useEffect, type FC } from 'react';

import { useCommentsPanelActions } from '@confluence/comments-panel-utils/entry-points/useCommentsPanel.ts';
import { LoadablePaint } from '@confluence/loadable';
import { SuspenseWithDataFetcher } from '@confluence/query-preloader-tools/entry-points/SuspenseWithDataFetcher.ts';

type CommentTypes = {
	pageWidthType?: string;
	showLabels: boolean;
	hasReactions: boolean;
	editorIsUserOffline?: boolean;
	hasCommentSessions?: boolean;
};

const ObjectCommentContainerLoader = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ObjectCommentContainer" */ './ObjectCommentContainer.tsx'
			)
		).ObjectCommentContainer,
});

export const ObjectCommentWrapper: FC<CommentTypes> = ({
	pageWidthType,
	showLabels,
	hasReactions,
	editorIsUserOffline,
	hasCommentSessions,
}) => {
	const { setShowGeneralComments } = useCommentsPanelActions();

	useEffect(() => {
		setShowGeneralComments(true);
		// eslint-disable-next-line react-hooks/exhaustive-deps -- we only want to set the comment type once on the comment mount
	}, []);

	return (
		<SuspenseWithDataFetcher dataFetcherName="object-comments">
			<ObjectCommentContainerLoader
				pageWidthType={pageWidthType}
				showLabels={showLabels}
				hasReactions={hasReactions}
				editorIsUserOffline={editorIsUserOffline}
				hasCommentSessions={hasCommentSessions}
			/>
		</SuspenseWithDataFetcher>
	);
};
